import { useTranslation } from "react-i18next";
import { useParams } from "react-router";

import { StationDetail } from "../features/stations/StationDetail";
import { useStation } from "../features/stations/hooks";

export function StationDetailRoute() {
  const { t } = useTranslation();
  const { id } = useParams();
  const query = useStation(id);

  if (!id) {
    return <p className="mx-auto max-w-3xl px-4 py-8 text-fg-mute">{t("stations.invalid_id")}</p>;
  }
  if (query.isLoading) {
    return <p className="mx-auto max-w-3xl px-4 py-8 text-fg-mute">{t("common.loading")}</p>;
  }
  if (query.isError) {
    return (
      <div className="mx-auto max-w-3xl space-y-3 px-4 py-8">
        <p className="text-ember">{t("stations.load_failed")}</p>
        <button
          type="button"
          onClick={() => query.refetch()}
          className="rounded-md bg-bg-deep px-3 py-1.5 text-sm font-medium text-fg hover:bg-surface-raised"
        >
          {t("common.retry")}
        </button>
      </div>
    );
  }
  if (!query.data) {
    return <p className="mx-auto max-w-3xl px-4 py-8 text-fg-mute">{t("stations.not_found")}</p>;
  }
  return <StationDetail station={query.data} />;
}
